import React, { useState } from "react";
import API from "../services";
import "swiper/css";
import 'swiper/css/pagination';
import {useLocation, useNavigate } from "react-router-dom";
import "./SportsPage.scss"
import { RootState } from "../models/RootState";
import { connect } from "react-redux";
import { setLobby, setSportsExchData, setSportsSBData } from "../store/authReducer";
// import Loader from "../assets/images/Strike_White_Logo_Transparent_GIF.gif";
import { getGameUrl } from "../store/authActions";
import ClassicExchEvents from "./ClassicExchEvents/ClassicExchEvents";
import ClassicSBEvents from "./ClassicSBEvents/ClassicSBEvents";
import { Loader } from "../constants/whitelabelEnv";
import { domain } from "../constants/Branding";
import { UserDetails } from "../models/UserDetails";
import { useTranslation } from "../hooks/useTranslation";


interface SportsPageProps {
  sportsExchData: any;
  setSportsExchData: (data: any) => void;
  exchAuthData: any;
  sportsSBData: any;
  setSportsSBData: (data: any) => void;
  sbAuthData: any;
  getGameUrl: (provider: any) => void;
  setLobby: (data: any) => void;
  lobby: string;
  userDetails: UserDetails;
  dynamicTextColors?: any;
  // classic: boolean;
  // setSportView: (value: boolean) => void;
}

const SportsPage: React.FC<SportsPageProps> = ({ sportsExchData, setSportsExchData, exchAuthData, sportsSBData, setSportsSBData, sbAuthData, getGameUrl, setLobby, lobby, userDetails, dynamicTextColors }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  // const [gameSrc, setGameSrc] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [gameData, setGameData] = useState<any>();

  // Get dynamic text color classes from Redux instead of calling function
  const textColorClass = dynamicTextColors?.pageTextColorClass || '';
  const tabTextColorClass = dynamicTextColors?.inputBoxTextColorClass || '';

  // const getSportsInfo = async (lobby: string) => {
  //   setLoading(true);
  //   let response;
  //   try {
  //     response = await API.post(`/webapp/get-sports-content`, {
  //       lobby: lobby
  //     });
  //   } catch (e) {
  //     console.log(e);
  //     setLoading(false);
  //     return;
  //   }

  //   if (response.data.status !== "RS_OK") {
  //     navigate("/home");
  //   }

  //   if (response && response.data.sections) {
  //     setGameData(response.data?.sections);
  //     if (lobby == "EXCHANGE") {
  //       setSportsExchData(response?.data?.sections);
  //     } else {
  //       setSportsSBData(response?.data?.sections);
  //     }
  //   }

  //   setLoading(false);
  // };

  // useEffect(() => {
  //   // if (sportsData && sportsData.length > 0) {
  //   //   setGameData(sportsData);
  //   // } else {
  //   //   getSportsInfo();
  //   // }
  //   // getGameUrl();
  //   getSportsData(lobby);
  // }, [lobby])

  // const getSportsData = (provider: string) => {
  //   setLobby(provider);
  //   if (classic) {
  //     return;
  //   }
  //   // setProviderTab(provider);
  //   if (provider === "EXCHANGE") {
  //     if (!(exchAuthData && exchAuthData?.token)) {
  //       // getGameUrl("EX123");
  //     }
  //     if (sportsExchData && sportsExchData.length > 0) {
  //       setGameData(sportsExchData);
  //     } else {
  //       getSportsInfo(provider);
  //     }
  //   } else {
  //     if (!(sbAuthData && sbAuthData?.token)) {
  //       // getGameUrl("SB123");
  //     }
  //     if (sportsSBData && sportsSBData.length > 0) {
  //       setGameData(sportsSBData);
  //     } else {
  //       getSportsInfo(provider);
  //     }

  //   }
  // }


  const handleFavoriteClick = async (game: any) => {
    setGameData((prevGameData: any) =>
      prevGameData?.map((section: any) => ({
        ...section,
        items: section?.items?.map((gameMap: any) =>
          gameMap?.id === game?.id
            ? { ...gameMap, isFavorite: !gameMap?.isFavorite }
            : gameMap
        ),
      }))
    );
    let response;
    try {
      // Make the API call to update the favorite status
      response = await API.post('/webapp/set-favorite', {
        category: game.category,
        id: game.id,
        isFavorite: !game.isFavorite,
        name: game?.name,
        provider: game?.provider,
        subProvider: game.subProvider,
        thumbnail: game.thumbnail,
        type: game.type,
        tgProviderId: game?.tgProviderId,
        tableId: game?.tableId,
        userKey: sessionStorage.getItem("userKey")
      });

    } catch (error) {
      console.error('Error updating favorite status:', error);
      // Revert the state change if the API call fails
    }

    if (response && response.data?.status === "RS_OK") {
      const updatedGameData = gameData?.map((section: any) => ({
        ...section,
        items: section?.items?.map((gameMap: any) =>
          gameMap?.id === game?.id
            ? { ...gameMap, isFavorite: !gameMap?.isFavorite }
            : gameMap
        ),
      }));
      setSportsExchData(updatedGameData);
    }
  };

  // const handleToggleChange = (e: any) => {
  //   setSportView(e.target.checked);
  //   setUserSportsView(e.target.checked);
  // };


  return (
    <div className={`flex flex-col px-3 mt-4 w-full pb-[7rem] py-[4rem] casino ${textColorClass}`}>
      {
        loading ? (
          <div className="home-loading">
            <img src={Loader(domain)} style={{ height: '10rem' }} />
          </div>
        ) : (
          <>
            {/* <div className="grid mb-2 justify-around grid-cols-2 gap-4">
              <NavLink to={`/play/${btoa(`::EX123:::site::`)}`}
                className={`nav-link`}>
                <div
                  className="flex-1 p-4 px-8 mx-auto bg-inputbox-color border border-border-color rounded-lg flex flex-col items-center"
                >
                  <div className="flex-col flex items-center justify-center">
                    <img src={exchangeIcon} alt="Exchange" className="w-6 h-8" />
                    <span className={`text-sm font-medium ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>EXCHANGE</span>
                  </div>
                </div>
              </NavLink>
              <NavLink to={`/play/${btoa(`::SB123:::site::`)}`}
                className={`nav-link`}>
                <div
                  className="flex-1 p-4 px-8 mx-auto bg-inputbox-color border border-border-color rounded-lg flex flex-col items-center"
                >
                  <div className="flex-col flex items-center justify-center">
                    <img src={sbIcon} alt="sportsbook" className="w-6 h-8" />
                    <span className={`text-sm font-medium ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>SPORTSBOOK</span>
                  </div>
                </div>
              </NavLink>
            </div> */}

            <div className={`flex justify-around items-center mb-4 bg-inputbox-color px-2 ${tabTextColorClass}`}
              style={{ marginLeft: '-0.75rem', marginRight: '-0.75rem', marginTop: '-1.5rem' }}>
              { userDetails?.exchangeProvider && (
                <div
                className={`px-4 pt-4 pb-2 cursor-pointer text-sm font-medium mx-2 border-b-2 ${lobby === 'EXCHANGE' ? 'border-border-color' : 'border-transparent opacity-50'} ${tabTextColorClass === 'dark-text' ? 'text-black' : 'text-white'
                  }`}
                onClick={() => setLobby('EXCHANGE')}
              >
                {t("sports.exchange").toUpperCase()}
              </div>)}
              { userDetails?.sportsbookProvider && (
                <div
                className={`px-4 pt-4 pb-2 cursor-pointer text-sm font-medium mx-2 border-b-2 ${lobby === 'SPORTSBOOK' ? 'border-border-color' : 'border-transparent opacity-50'} ${tabTextColorClass === 'dark-text' ? 'text-black' : 'text-white'
                  }`}
                onClick={() => setLobby('SPORTSBOOK')}
              >
                {t("sports.sportsbook").toUpperCase()}
              </div>)}
              {/* <div className="flex flex-col justify-center pt-2 pb-2 text-white text-[10px]">
                <div>Classic View</div>
                <div className="flex justify-center">
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      className="sr-only peer"
                      checked={classic}
                      onChange={handleToggleChange}
                    />
                    <div className="w-[1.9rem] h-4 bg-gray-600 rounded-full peer-checked:bg-border-color transition-colors duration-300"></div>
                    <div className="absolute left-0.5 top-0.5 w-[0.8rem] h-3 bg-white rounded-full transition-transform duration-300 peer-checked:translate-x-full"></div>
                  </label>
                </div>
              </div> */}
            </div>

            {
            // classic ? (
              lobby === "EXCHANGE" && userDetails?.exchangeProvider ? (
                <ClassicExchEvents />
              ) : userDetails?.sportsbookProvider ? (
                <ClassicSBEvents />
              ) : (
                <></>
              )
            // ) :
            //   <div className="main-section">
            //     {gameData?.map((section: any, index: number) => (
            //       <div key={index} style={{ marginBottom: '10px' }}>
            //         <div style={{ display: 'flex', alignItems: 'center', paddingBottom: '0.75rem' }}>
            //           <div>
            //             <img src={section?.sectionIcon !== "" ? section?.sectionIcon : `${S3_IMG}/casino.svg`} alt={section?.sectionTitle} style={{ width: '1rem', marginRight: '5px' }} />
            //           </div>
            //           <span className="section-title">{section.sectionTitle}</span>
            //         </div>
            //         <Swiper
            //           spaceBetween={10}
            //           slidesPerView={2.1}
            //           breakpoints={{
            //             640: { slidesPerView: 3.5, spaceBetween: 10 },
            //             768: { slidesPerView: 3.5, spaceBetween: 20 },
            //             1024: { slidesPerView: 4, spaceBetween: 30 },
            //           }}
            //         >
            //           {section?.items.map((game: any, gameIndex: number) => (
            //             <SwiperSlide key={game?.id + gameIndex}>
            //               <div style={{}}>
            //                 <NavLink
            //                   to={
            //                     (game.type.toLowerCase() === "sport" || game.type.toLowerCase() === "competition")
            //                       ? `/events/${btoa(`${game?.id}#${game?.name}#${game?.provider}#${game?.type}`)}` :
            //                       game?.provider == "SPORTSBOOK" ?
            //                         `/sb-markets/${btoa(`${game?.id}`)}`
            //                         : `/markets/${btoa(`${game?.id}`)}`
            //                   }
            //                   className={`nav-link`}
            //                 >
            //                   <div className="game-img relative" style={{ marginBottom: '0.5rem', height: '7.5rem', width: '10rem' }}>
            //                     <img src={game?.thumbnail} alt={game?.gameName} style={{ width: '100%', height: '100%', borderRadius: '12px' }} />
            //                     <div style={{ position: 'absolute', top: '5px', right: '5px' }}>
            //                       {game?.isFavorite ? <FavoriteOutlined
            //                         className="gold-favourite-img"
            //                         titleAccess={"remove from favourites"}
            //                         onClick={(e) => {
            //                           e.preventDefault();
            //                           handleFavoriteClick(game);
            //                         }}
            //                       /> : <FavoriteBorderOutlined
            //                         className="red-favourite-img"
            //                         titleAccess={"remove from favourites"}
            //                         onClick={(e) => {
            //                           e.preventDefault();
            //                           handleFavoriteClick(game);
            //                         }}
            //                       />}
            //                     </div>
            //                   </div>
            //                 </NavLink>
            //                 <div className="game-name">{game?.name}</div>
            //                 <div className="prov-name">{game?.provider}</div>
            //               </div>
            //             </SwiperSlide>
            //           ))}
            //         </Swiper>
            //       </div>
            //     ))}

            //   </div>
            }
          </>
        )
      }
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    sportsExchData: state.userDetails?.sportsExchData,
    exchAuthData: state.userDetails?.exchData,
    sportsSBData: state.userDetails?.sportSBData,
    sbAuthData: state.userDetails?.sbData,
    lobby: state.userDetails?.lobby,
    userDetails: state.userDetails?.userDetails,
    dynamicTextColors: state.userDetails?.dynamicTextColors,
    // classic: state.userDetails?.userDetails?.IsClassic,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    setSportsExchData: (data: any) => {
      dispatch(setSportsExchData(data));
    },
    setSportsSBData: (data: any) => {
      dispatch(setSportsSBData(data));
    },
    getGameUrl: (provider: string) => {
      dispatch(getGameUrl(provider));
    },
    setLobby: (provider: string) => {
      dispatch(setLobby(provider));
    },
    // setSportView: (value: boolean) => {
    //   dispatch(setSportView(value));
    // },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SportsPage);
